/* GENERATED BY DECAFFEINATE */

// This is a little shitty, but implement a simple (read: no-op) RollingNumber
// That way, we get rid of a complicated function, but keep existing JS happy.
// If you're looking, this thing is used in the headerbar, via instantevents.

class RollingNumber {
	constructor(container, number, params) {
		this.number = number;
		this.params = params;
		this.el = container;
		this.ready = true;
		this.set(this.number);
	}

	increment() {
		return this.set(this.number + 1);
	}

	decrement() {
		return this.set(this.number - 1);
	}

	set(number) {
		this.number = number;
		const cappedNumber = this.number > 99 ? "99+" : this.number;
		return this.el.innerHTML = cappedNumber;
	}

	setWithoutRoll(number) {
		return this.set(number);
	}

	get() {
		return this.number;
	}

	getDial() {
		return this.get();
	}

	cancel() {
		// no-op!
		return true;
	}
};

window.RollingNumber = RollingNumber;
export default RollingNumber;



// WEBPACK FOOTER //
// ./src/legacy/rolling_number.js